import { render, staticRenderFns } from "./UserInfomation.vue?vue&type=template&id=30b3cad6&"
import script from "./UserInfomation.vue?vue&type=script&lang=js&"
export * from "./UserInfomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports